import { z } from 'zod';
import { toUpper, snakeCase, deburr, uniq, compact } from 'lodash';

const stringToEnumKey = (str: string) =>
  toUpper(snakeCase(deburr(str.replace(/[^a-zA-Z0-9_\s]/g, ''))));

export const CustomFreightTagsSchema = z
  .array(z.string())
  .transform((tags) => uniq(compact(tags.map(stringToEnumKey))));

export type CustomFreightTags = z.infer<typeof CustomFreightTagsSchema>;
